import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import immutableToJS from 'helpers/immutableToJS';
import { dispatchRestMaker } from 'helpers/utils';
import {
  injectIntl,
  HeaderTitle,
  ScrollToTop,
  SearchComponent,
} from 'components';
import Members from 'containers/Members';
import accountActions from 'redux/accounts/actions';
import memberActions from 'redux/members/actions';
import { selectState } from 'redux/selectors';

const styles = theme => ({
  button: {
    backgroundColor: '#ffd24c',
    borderRadius: 5,
    marginBottom: 10,
  },
  buttonLabel: {
    color: '#313131',
    fontSize: 14,
    fontWeight: 500,
  },
  badgeRoot: {
    marginBottom: 5,
  },
  notificationBadge: {
    backgroundColor: '#ff602e',
  },
  notificationBadgeDesk: {
    backgroundColor: '#ff602e',
    right: -30,
  },
  tab: { backgroundColor: '#ffffff' },
  tabIndicator: { backgroundColor: '#5b98ed' },
  tabLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 10,
    },
    fontWeight: 600,
    color: '#5b98ed',
  },
  tabsContainer: {
    borderRadius: 5,
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
});

class OrganizationLoginMembers extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    globals: PropTypes.shape({}),
    isMember: PropTypes.bool,
    refreshToken: PropTypes.func,
  };

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  state = {
    searchText: '',
  };

  handleCancelSearch = () => this.setState({ searchText: '' });

  handleSearchText = value => this.setState({ searchText: value });

  render() {
    const { currentUser } = this.context;
    const {
      history,
      formatMessage,
    } = this.props;
    const { searchText } = this.state;

    return (
      <div className="settings-organization-login-member-page row">
        <HeaderTitle>{formatMessage('Members')}</HeaderTitle>
        <SearchComponent
          cancelSearch={this.handleCancelSearch}
          placeholder={formatMessage('Team Members')}
          search={this.handleSearchText}
          searchText={searchText}
        />
        <div className="owner-info col-sm-6">
          <div className="top-title">
            {formatMessage('Account Owner')}:
          </div>
          <div className="owner">
            <div className="owner-title">
              <span className="company-name">{`${get(currentUser, 'account.profile.companyName')} - `}</span>
              <span className="profile-name">{`${get(currentUser, 'account.profile.firstName')} ${get(currentUser, 'account.profile.lastName')}`}</span>
              {/* - ${get(currentUser, 'account.email')} */}
            </div>
          </div>
        </div>
        <Members history={history} searchText={searchText} />
        <ScrollToTop invisibleHeight={400} />
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('accounts', 'accounts')(state, 'accounts'),
  ...selectState('members', 'members')(state, 'members'),
  ...selectState('options', 'permissions')(state, 'permissions'),
});

const mapDispatchToProps = dispatch => ({
  ...dispatchRestMaker([
    [memberActions, 'member'],
  ])(dispatch),
  ...dispatchRestMaker([
    [accountActions, 'account'],
  ])(dispatch),
});

export default compose(
  setDisplayName('OrganizationLoginMembers'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(OrganizationLoginMembers);
